var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgH8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.84 135.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-Info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1465912410832",
    "data-name": 1465912410832
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.92,135.14l-19.31-19.3h-29a9.12,9.12,0,0,1-6.75-3A9.31,9.31,0,0,1,0,106.18V9.65A9.22,9.22,0,0,1,2.9,2.9,9.26,9.26,0,0,1,9.65,0h96.53a9.35,9.35,0,0,1,6.68,2.9,9.15,9.15,0,0,1,3,6.75v96.53a10.22,10.22,0,0,1-9.66,9.66h-29l-19.3,19.3Z",
    transform: "translate(0 0)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.06,57.2a11.7,11.7,0,0,0,1.08,1.93l1.22,1.92c.72-.39,1.41-.87,2.17-1.31,1.43-.83,6.23-3.15,7.67-3,.34,1.29-1.32,7.24-1.72,8.91-.71,2.94-1.4,5.85-2.1,8.78-1.09,4.68-5.12,16.69.49,18.93,2.2.88,4.86.33,7-.33a48.16,48.16,0,0,0,15.6-8.89c.44-.38,1.08-.85,1.51-1.25l2.8-2.64c-.39-.94-2.17-2.84-2.49-3.63-.57.29-2.61,1.87-4.33,2.83-1.08.6-3.89,2.08-5.25,1.8-.79-1.8,1-7.07,1.49-9.12.74-2.91,1.54-5.77,2.26-8.72,1-4.17,4.58-14.44,1.9-18.11-1.76-2.41-5.55-1.35-8.4-.4a47.38,47.38,0,0,0-7.72,3.38,70.47,70.47,0,0,0-12.36,8.24,6.32,6.32,0,0,1-.82.65Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,17.21c-11.5,1-13,19.1,0,17.45a10.38,10.38,0,0,0,9-8.8c.6-5.71-3.45-9.13-9.07-8.65Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH8);
export default __webpack_public_path__ + "static/media/H8.37b0666ebdf82c4344eaa73030f85d86.svg";
export { ForwardRef as ReactComponent };